import script from "./PayModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PayModal.vue?vue&type=script&setup=true&lang=js"

import "./PayModal.vue?vue&type=style&index=0&id=6f355e8e&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f355e8e"]])

export default __exports__